import { render } from "./ProfileSettingsVerifyIdCardPage.vue?vue&type=template&id=ff5dd5fe&ts=true"
import script from "./ProfileSettingsVerifyIdCardPage.vue?vue&type=script&lang=ts"
export * from "./ProfileSettingsVerifyIdCardPage.vue?vue&type=script&lang=ts"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__